import { TtCombobox } from './TtCombobox.js';
import './tt-option/tt-option.js';

if (typeof window !== 'undefined') {
  if (!window.customElements.get('tt-combobox')) {
    window.customElements.define('tt-combobox', TtCombobox);
  }
}

export { TtCombobox };
